import { YOUR_DETAILS_FIELDS_REVIEW } from './you-details-fields-review.config';

// Local field configuration (migrated from jl-design-system/form/fields/email)
const EMAIL = {
  name: 'email',
  id: 'email',
  type: 'email',
  label: 'Email',
  required: true,
  validationMessageKeys: {
    required: 'Please enter your email address',
  },
};

export const REVIEW_YOUR_DETAILS = [
  {
    term: 'First name',
    fieldName: 'firstName',
    fieldExtraProps: YOUR_DETAILS_FIELDS_REVIEW.firstName,
  },
  {
    term: 'Last name',
    fieldName: 'lastName',
    fieldExtraProps: YOUR_DETAILS_FIELDS_REVIEW.lastName,
  },
  {
    term: 'Phone number',
    fieldName: 'phoneNumber',
    fieldExtraProps: YOUR_DETAILS_FIELDS_REVIEW.phoneNumber,
  },
  {
    term: 'Email',
    fieldName: 'email',
    edit: false,
    fieldExtraProps: { ...EMAIL },
  },
];
